import React from "react";
import style from "./Skeleton.module.sass";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const SkeletonLoader = ({ cards }) => {
  return Array(cards)
    .fill(0)
    .map((_, i) => (
      // zrobic light mode
      <SkeletonTheme key={`user_loader_${i}`}>
        <div className={style.skeleton} key={i}>
          <Skeleton width={25} height={25} borderRadius={5} />
          <div className={style.content}>
            <Skeleton />
            <Skeleton />
            <Skeleton />
          </div>
        </div>
      </SkeletonTheme>
    ));
};

export default SkeletonLoader;
